import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

const DatenschutzPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Datenschutzerklärung - Dein Gutachten Direkt</title>
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.dein-gutachten-direkt.de/datenschutz" />
      </Helmet>
      
      <Header />
      
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Datenschutzerklärung</h1>
          <p className="text-lg text-gray-600 mb-12">Informationen zur Verarbeitung personenbezogener Daten</p>
          
          {/* 1. Verantwortlicher */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Verantwortlicher</h2>
            <div className="prose prose-lg">
              <p className="text-gray-700 mb-2">Verantwortlich für die Datenverarbeitung ist:</p>
              <p className="text-gray-700 mb-1"><strong>Dein-Gutachten-Direkt GbR</strong></p>
              <p className="text-gray-700 mb-1">Möwenstraße 2, 25462 Rellingen</p>
              <p className="text-gray-700 mb-1">
                E-Mail: <a href="mailto:info@dein-gutachten-direkt.de" className="text-brand-green hover:text-brand-green-dark">info@dein-gutachten-direkt.de</a>
              </p>
              <p className="text-gray-700">
                Telefon: <a href="tel:041018471160" className="text-brand-green hover:text-brand-green-dark">04101 8471160</a>
              </p>
            </div>
          </section>
          
          {/* 2. Allgemeine Hinweise */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Allgemeine Hinweise</h2>
            <div className="prose prose-lg">
              <p className="text-gray-700">
                Wir verarbeiten personenbezogene Daten nur, soweit dies erforderlich ist, um unsere Website bereitzustellen, Anfragen zu bearbeiten und unsere Leistungen rund um Unfallgutachten und Partnerfälle abzuwickeln.
              </p>
            </div>
          </section>
          
          {/* 3. Zugriffsdaten */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Zugriffsdaten (Server-Logfiles)</h2>
            <div className="prose prose-lg">
              <p className="text-gray-700 mb-4">Beim Aufruf unserer Website werden technisch bedingt Daten verarbeitet, z. B.:</p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
                <li>IP-Adresse (ggf. gekürzt)</li>
                <li>Datum und Uhrzeit des Zugriffs</li>
                <li>aufgerufene Seite/Datei</li>
                <li>Browsertyp und Betriebssystem</li>
                <li>Referrer-URL</li>
              </ul>
              <p className="text-gray-700">
                Diese Daten werden zur technischen Sicherheit und Stabilität genutzt und nicht zur Erstellung von Nutzerprofilen verwendet.
              </p>
            </div>
          </section>
          
          {/* 4. Kontaktaufnahme */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Kontaktaufnahme</h2>
            <div className="prose prose-lg">
              <p className="text-gray-700">
                Wenn Sie uns per E-Mail oder über Kontaktformulare kontaktieren, verarbeiten wir Ihre Angaben zur Bearbeitung der Anfrage und für mögliche Rückfragen.
              </p>
            </div>
          </section>
          
          {/* 5. Partner-Portal */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Partner-Portal (Registrierung, Onboarding, Fallübermittlung)</h2>
            <div className="prose prose-lg">
              <p className="text-gray-700 mb-4">Wenn sich Partner registrieren und das Portal nutzen, verarbeiten wir insbesondere:</p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
                <li>Kontaktdaten (z. B. Name, E-Mail, Telefonnummer optional)</li>
                <li>Firmendaten (Adresse, ggf. USt-ID)</li>
                <li>Falldaten zum Unfall (z. B. Ort, Datum, Kennzeichen, Angaben zum Schaden)</li>
                <li>hochgeladene Bilder und Dokumente (z. B. Fahrzeugschein, Fotos)</li>
              </ul>
              <p className="text-gray-700">
                Die Verarbeitung erfolgt zur Durchführung des Partnervertrags und zur Bearbeitung des jeweiligen Falls.
              </p>
            </div>
          </section>
          
          {/* 6. Uploads */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Uploads von Bildern und Dokumenten</h2>
            <div className="prose prose-lg">
              <p className="text-gray-700 mb-2">
                Im Portal können Bilder und Dokumente hochgeladen werden. Bitte laden Sie nur Inhalte hoch, die für die Bearbeitung erforderlich sind.
              </p>
              <p className="text-gray-700">
                Uploads werden gespeichert, um den Fall zu bearbeiten und Rückfragen zu vermeiden.
              </p>
            </div>
          </section>
          
          {/* 7. E-Mail-Versand */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. E-Mail-Versand (Resend)</h2>
            <div className="prose prose-lg">
              <p className="text-gray-700 mb-4">
                Für den Versand von System-E-Mails (z. B. Bestätigung, Verifizierungslinks, Statushinweise) nutzen wir einen Versanddienstleister.
              </p>
              <p className="text-gray-700 mb-2"><strong>Dienst:</strong> Resend</p>
              <p className="text-gray-700">
                Dabei wird Ihre E-Mail-Adresse verarbeitet, um die Nachricht zustellen zu können.
              </p>
            </div>
          </section>
          
          {/* 8. Zahlungen */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Zahlungen (Stripe)</h2>
            <div className="prose prose-lg">
              <p className="text-gray-700 mb-4">Für die Abwicklung von Abonnements und Zahlungen nutzen wir Stripe.</p>
              <p className="text-gray-700 mb-2"><strong>Dienst:</strong> Stripe</p>
              <p className="text-gray-700">
                Dabei werden Zahlungsdaten direkt über Stripe verarbeitet. Wir erhalten keine vollständigen Zahlungsdaten (z. B. keine Kreditkartennummern), sondern lediglich Statusinformationen zur Zahlung.
              </p>
            </div>
          </section>
          
          {/* 9. Rechtsgrundlagen */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Rechtsgrundlagen</h2>
            <div className="prose prose-lg">
              <p className="text-gray-700 mb-4">Je nach Zweck verarbeiten wir Daten auf folgenden Grundlagen:</p>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Art. 6 Abs. 1 lit. b DSGVO (Vertrag / vorvertragliche Maßnahmen)</li>
                <li>Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse, z. B. IT-Sicherheit)</li>
                <li>Art. 6 Abs. 1 lit. c DSGVO (rechtliche Verpflichtung, sofern erforderlich)</li>
              </ul>
            </div>
          </section>
          
          {/* 10. Speicherdauer */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Speicherdauer</h2>
            <div className="prose prose-lg">
              <p className="text-gray-700">
                Wir speichern personenbezogene Daten nur so lange, wie es für den jeweiligen Zweck erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen.
              </p>
            </div>
          </section>
          
          {/* 11. Weitergabe */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Weitergabe an Dritte</h2>
            <div className="prose prose-lg">
              <p className="text-gray-700 mb-4">Eine Weitergabe erfolgt nur, wenn dies erforderlich ist, z. B.:</p>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>zur Zahlungsabwicklung (Stripe)</li>
                <li>für System-E-Mails (Resend)</li>
                <li>zur Bearbeitung und Abwicklung eines Falls (z. B. wenn Unterlagen an Beteiligte übermittelt werden müssen)</li>
              </ul>
            </div>
          </section>
          
          {/* 12. Ihre Rechte */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Ihre Rechte</h2>
            <div className="prose prose-lg">
              <p className="text-gray-700 mb-4">Sie haben im Rahmen der DSGVO u. a. folgende Rechte:</p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
                <li>Auskunft über gespeicherte Daten</li>
                <li>Berichtigung unrichtiger Daten</li>
                <li>Löschung, sofern keine Pflicht zur Aufbewahrung besteht</li>
                <li>Einschränkung der Verarbeitung</li>
                <li>Widerspruch gegen Verarbeitung</li>
                <li>Datenübertragbarkeit</li>
              </ul>
              <p className="text-gray-700">
                Anfragen bitte an: <a href="mailto:info@dein-gutachten-direkt.de" className="text-brand-green hover:text-brand-green-dark">info@dein-gutachten-direkt.de</a>
              </p>
            </div>
          </section>
          
          {/* 13. Beschwerderecht */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">13. Beschwerderecht</h2>
            <div className="prose prose-lg">
              <p className="text-gray-700">
                Sie haben das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren.
              </p>
            </div>
          </section>
          
          {/* 14. Änderungen */}
          <section className="pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">14. Änderungen dieser Datenschutzerklärung</h2>
            <div className="prose prose-lg">
              <p className="text-gray-700">
                Wir können diese Datenschutzerklärung anpassen, wenn sich Funktionen oder rechtliche Anforderungen ändern.
              </p>
            </div>
          </section>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default DatenschutzPage;
